import { css, Interpolation, Theme } from '@emotion/react'
import { OrderDirection } from '__generatedTypes__/globalTypes'

export const scrollableWrapper: (padding: number) => Interpolation<Theme> = (padding) => css`
  width: calc(100% + ${padding * 2}px);
  margin: 0 -${padding}px;
  padding: 0 ${padding}px;
  overflow-x: auto;

  &.scrollable {
    padding-bottom: 8px;
  }
`

export const wrapper: (minWidth: number) => Interpolation<Theme> = (minWidth) => css`
  min-width: ${minWidth}px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const header: Interpolation<Theme> = (theme) => css`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 12px;
  gap: 24px;
  background: ${theme.colors.grayHover};
  border-radius: 14px;
  min-height: 48px;
`

export const row: (isSortable?: boolean, isActive?: boolean) => Interpolation<Theme> =
  (isSortable, isActive) => (theme) =>
    css`
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 12px;
      gap: 24px;
      background: ${isActive ? theme.colors.grayHover : theme.backgrounds.backgroundFour};
      border: 1px solid ${theme.backgrounds.backgroundOne};
      box-shadow: ${theme.boxShadows.small};
      border-radius: 14px;
      min-height: 48px;

      ${isSortable &&
      css`
        cursor: pointer;
      `}

      &:not(:hover) .show-on-hover {
        display: none;
      }
    `

export const cell: (flex?: number | string) => Interpolation<Theme> = (flex) => (theme) =>
  css`
    flex: ${flex ?? 1};
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.typographyColors.typographyTwo};
    font-family: ${theme.fonts.family.PlusJakartaSans};
    overflow-wrap: anywhere;
  `

export const titleCell: (order: { available?: boolean; direction?: OrderDirection | null }) => Interpolation<Theme> =
  ({ available, direction }) =>
  (theme) =>
    css`
      position: relative;
      user-select: none;

      .table-order-icon {
        height: 18px;
        width: 18px;
        display: ${!available || !direction ? 'none' : 'block'};
        transform: rotate(${direction === OrderDirection.DESC ? 180 : 0}deg);
        color: ${direction ? theme.typographyColors.typographyTwo : theme.typographyColors.typographyThree};
        transition: all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut};
        position: absolute;
        top: 0;
        right: 0;
      }

      ${available &&
      css`
        cursor: pointer;
        :hover .table-order-icon {
          display: block;
        }
      `}
    `

export const checkbox: Interpolation<Theme> = css`
  min-width: 24px;
`

export const dndSpace: Interpolation<Theme> = css`
  min-width: 20px;
`

export const message: Interpolation<Theme> = (theme) =>
  css`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${theme.backgrounds.backgroundFour};
    border: 1px solid ${theme.backgrounds.backgroundOne};
    box-shadow: ${theme.boxShadows.small};
    border-radius: 14px;
    min-height: 70px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.typographyColors.typographyTwo};
    font-family: ${theme.fonts.family.PlusJakartaSans};
  `

export const loader: Interpolation<Theme> = css`
  min-height: 200px;
`
